import $ from "jquery";
import Component from "vue-class-component";
import { EventBus } from "../Controls/EventBus";
import { VueBase } from "../Controls/VueBase";
import { ParametresInstance } from "../Controls/Parameters";
import ModalAjoutSocieteComponent from "./modalAjoutSociete/modalAjoutSociete";
import EventConstants from "../Controls/EventConstants";

@Component({
	components: {
		AdministratifSocieteComponent: require("./administratif/administratifSociete.vue.html"),
		ParametrageSocieteComponent: require("./parametrage/parametrageSociete.vue.html"),
		ReglementsSocieteComponent: require("./reglements/reglementsSociete.vue.html"),
		DsnSocieteComponent: require("./dsn/dsnSociete.vue.html"),
		ModalAjoutSocieteComponent: require("./modalAjoutSociete/modalAjoutSociete.vue.html")
	}
})
export default class SocieteComponent extends VueBase {
	public tab = 0;
	public currentId = -1;
	public isModified = false;
	public modalAjoutSociete?: ModalAjoutSocieteComponent = undefined;

	public mounted(): void {
    	this.changeTab(this.tab);

    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.isModified = false;
    		this.changeTab(this.tab);
    	});
	}

	public changeTab(index: any): void {
    	if (this.isModified) {
   		return;
   	}
    	this.tab = index;

    	const child: any = this.$children[this.tab];
    	child.Init();
	}

	public onCurentTabModifier(isModified: any): void {
    	this.isModified = isModified;
	}

	public ajouter(): void {
    	if (ParametresInstance.societeCourante == undefined || ParametresInstance.societeCourante.Code == undefined) {
   		return;
   	}
    	if (this.modalAjoutSociete == undefined) {
   		this.modalAjoutSociete = this.$refs.modalAjoutSociete as ModalAjoutSocieteComponent;
   	}

    	if (this.modalAjoutSociete != undefined) {
   		this.modalAjoutSociete.init();
   	}

    	$("#modalAjoutSociete").modal("show");
	}
}




// WEBPACK FOOTER //
// ./src/components/ficheSociete/ficheSociete.ts